import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../services/baseQuery';
import { toCamelCase } from '../../grid/utils';
import type {
  BankAccountBalanceReportOptions,
  BankAccountBalanceReportRequest,
  BankAccountBalanceReportResult,
} from '../types';

type ApiEnvelope = { Code?: number; code?: number; data?: unknown; Data?: unknown };

const API_URL = '/umbraco/api/BankAccountBalanceReport';

const transformResponse = <T>(response: ApiEnvelope): T => {
  if ((response.Code ?? response.code) !== 1) {
    throw new Error('Failed to load bank account balance report.');
  }

  return toCamelCase(response.data ?? response.Data ?? {}) as T;
};

export const bankAccountBalanceReportApi = createApi({
  reducerPath: 'bankAccountBalanceReportApi',
  baseQuery,
  endpoints: (builder) => ({
    getOptions: builder.query<BankAccountBalanceReportOptions, void>({
      query: () => `${API_URL}/GetOptions`,
      transformResponse: (response: ApiEnvelope) =>
        transformResponse<BankAccountBalanceReportOptions>(response),
      keepUnusedDataFor: 300,
    }),
    generateReport: builder.query<BankAccountBalanceReportResult, BankAccountBalanceReportRequest>({
      query: (body) => ({ url: `${API_URL}/Generate`, method: 'POST', body }),
      transformResponse: (response: ApiEnvelope) =>
        transformResponse<BankAccountBalanceReportResult>(response),
    }),
  }),
});

export const { useGetOptionsQuery, useLazyGenerateReportQuery } = bankAccountBalanceReportApi;
